'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = require('events');

var _ipos = require('./ipos');

var _ipos2 = _interopRequireDefault(_ipos);

var _mobile = require('./mobile');

var _mobile2 = _interopRequireDefault(_mobile);

var _points = require('./points');

var _points2 = _interopRequireDefault(_points);

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var create = _util2.default.create,
    emit = _util2.default.emit,
    showLoading = _util2.default.showLoading,
    hideLoading = _util2.default.hideLoading,
    getInstance = _util2.default.getInstance,
    cleanPacks = _util2.default.cleanPacks,
    iposCleanPacks = _util2.default.iposCleanPacks,
    cleanSpvStorage = _util2.default.cleanSpvStorage,
    toFirst = _util2.default.toFirst;

var log = console.log;

var getCart = void 0,
    Group = void 0,
    _deletePacks = void 0,
    favoriteAjax = void 0,
    _submit = void 0,
    _getVariant = void 0;

var Model = function (_EventEmitter) {
  (0, _inherits3.default)(Model, _EventEmitter);

  function Model() {
    (0, _classCallCheck3.default)(this, Model);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Model.__proto__ || (0, _getPrototypeOf2.default)(Model)).call(this));

    _this.model = _this._getModel();
    cleanSpvStorage();
    return _this;
  }

  (0, _createClass3.default)(Model, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      getCart = this.model.getCart;
      Group = this.model.Group;
      _deletePacks = this.model.deletePacks;
      favoriteAjax = this.model.favoriteAjax;
      _submit = this.model.submit;
      _getVariant = this.model.getVariant;
      showLoading();
      getCart().then(function (_ref) {
        var data = _ref.data;

        hideLoading();
        _this2.data = data;
        _this2._setDefault();
        _this2._setGroupsModel();
        emit('init', _this2.data);
      }).catch(function (_ref2) {
        var message = _ref2.message;

        emit('error', { message: message });
      });
    }
  }, {
    key: 'getStock',
    value: function getStock(spvId) {
      return this.model.getStock(spvId);
    }

    // ipos only

  }, {
    key: 'getIposAllPakcs',
    value: function getIposAllPakcs() {
      // preview packs to order: packs(giftpacks)/addible/giftpacks
      var previewPacks = [];
      this.data.groups.forEach(function (group) {
        if (!group.allChecked) {
          return;
        }
        var poolSize = group.giftPacksPool ? group.giftPacksPool.length : 0;
        group.packs && group.packs.forEach(function (pack) {
          if (pack.p_checked || pack.benefit && pack.benefit.id) {
            previewPacks.push(pack);
          }
          // pack.giftCampaigns && pack.giftCampaigns.forEach(g => {
          //   g.sections.forEach(s => {
          //     s.satisfied && s.owned && s.products.forEach(p => {
          //       p.giftPacks.forEach(gp => {
          //         if(gp.storeCount || gp.warehouseCount){
          //           previewPacks.push(gp)
          //         }
          //       })
          //     })
          //   })
          // })  
        });
        group.addiblePacks && group.addiblePacks.forEach(function (a) {
          a.owned && previewPacks.push(a);
        });
        group.giftPacks && group.giftPacks.forEach(function (g) {
          g.poolSize = poolSize; // 选赠品判断选购池需要该字段
          g.owned && previewPacks.push(g);
        });
        group.giftCampaigns && group.giftCampaigns.forEach(function (g) {
          g.sections.forEach(function (s) {
            s.satisfied && s.owned && s.products.forEach(function (p) {
              p.giftPacks.forEach(function (gp) {
                if (gp.storeCount || gp.warehouseCount) {
                  previewPacks.push(gp);
                }
              });
            });
          });
        });
      });
      return previewPacks;
    }

    // ipos only

  }, {
    key: 'getIposCleanedAllPakcs',
    value: function getIposCleanedAllPakcs() {
      return iposCleanPacks(this.getIposAllPakcs());
    }
  }, {
    key: 'iposCheckAllFromStore',
    value: function iposCheckAllFromStore() {
      this.groups.forEach(function (group) {
        if (!group.data.allChecked) {
          return;
        }
        group.checkAllFromStore();
      });
    }
  }, {
    key: 'submit',
    value: function submit(packs) {
      return _submit(packs);
    }
  }, {
    key: '_setDefault',
    value: function _setDefault() {
      this.data.disableDeleteMultiple = false;
      this.data.disableFavorite = false;
      this.data.disabledSubmit = true;
      this.data.showExclusiveTip = false;
      this._resetDefault();
    }
  }, {
    key: '_resetDefault',
    value: function _resetDefault() {
      !this.data.groups && (this.data.groups = []);
      !this.data.addiblePacks && (this.data.addiblePacks = []);
      !this.data.giftPacks && (this.data.giftPacks = []);
      !this.data.invalidPacks && (this.data.invalidPacks = []);
      !this.data.labels && (this.data.labels = []);
    }
  }, {
    key: 'addPack',
    value: function addPack(pack) {
      if (!this.groups.length) {
        this.initGroups();
      }
      var isOversea = pack.isOversea;
      var addType = isOversea ? 'OVERSEA' : 'NORMAL';
      var anotherType = isOversea ? 'NORMAL' : 'OVERSEA';
      var addGroup = this.getGroup(addType);
      var anotherGroup = this.getGroup(anotherType);
      toFirst(this.groups, addGroup);
      toFirst(this.data.groups, addGroup.data);
      var alreadyExist = addGroup.data.packs.some(function (p) {
        return pack.spv.id === p.spv.id;
      });
      if (alreadyExist) {
        addGroup.addExistPack(pack);
        if (anotherGroup.data.packs.length) {
          if (!addGroup.data.allChecked) {
            this.emptyAllPreview();
          }
        }
        return;
      }
      addGroup.addPack(pack);
      if (anotherGroup.data.packs.length) {
        // there are two groups
        if (addGroup.data.allChecked) {
          addGroup.selectAll().refreshAllPreview(false, { data: pack });
        } else {
          this.emptyAllPreview();
        }
      } else {
        // if there is only one group, 
        // select all packs and refresh preview
        addGroup.selectAll().refreshAllPreview(false, { data: pack });
      }
    }
  }, {
    key: 'emptyAllPreview',
    value: function emptyAllPreview() {
      this.groups.forEach(function (group) {
        group.unselectAll();
        group.data.allChecked = false;
        group.refreshAllPreview();
      });
    }
  }, {
    key: 'getGroup',
    value: function getGroup(type) {
      return this.groups.filter(function (group) {
        return group.data.type === type;
      })[0];
    }
  }, {
    key: 'initGroups',
    value: function initGroups() {
      this.data.groups.push({
        packs: [],
        labels: [],
        giftPacks: [],
        addiblePacks: [],
        type: 'NORMAL',
        exclusive: true,
        title: '普通商品'
      });
      this.data.groups.push({
        packs: [],
        labels: [],
        giftPacks: [],
        addiblePacks: [],
        type: 'OVERSEA',
        exclusive: true,
        title: '海外购商品',
        description: '应海关要求，必须和普通商品分开下单，敬请谅解'
      });
      this._setGroupsModel();
    }
  }, {
    key: 'deletePacks',
    value: function deletePacks(packs) {
      var _this3 = this;

      return _deletePacks(packs).then(function () {
        _this3.removePacks(packs);
      }).catch(function (_ref3) {
        var message = _ref3.message;

        emit('error', {
          message: message
        });
        return _promise2.default.reject();
      });
    }
  }, {
    key: 'getVariant',
    value: function getVariant(productId) {
      return _getVariant(productId);
    }
  }, {
    key: 'favorite',
    value: function favorite(packs) {
      var _this4 = this;

      return favoriteAjax(packs).then(function () {
        _this4.removePacks(packs);
      }).catch(function (_ref4) {
        var message = _ref4.message;

        emit('error', {
          message: message
        });
        return _promise2.default.reject();
      });
    }
  }, {
    key: 'removePacks',
    value: function removePacks(packs) {
      var _this5 = this;

      console.log('removePacks');
      this.groups.forEach(function (group) {
        group.removePacks(packs);
        if ((_util2.default.getClient() === 'mobile' || _util2.default.getClient() === 'points') && !_this5.data.editMode) {
          group.refreshPreview();
        }
        if (_util2.default.getClient() === 'ipos') {
          if (group.data.allChecked) {
            group.refreshPreview();
          }
        }
      });
    }

    // reloadGroup () {
    //   let oldGroup = this.groups[0]
    //   if (!oldGroup) {
    //     return
    //   }
    //   console.log('reloadGroup')
    //   oldGroup
    //     .refreshPreview()
    //     .then(({ code , data }) => {
    //       let newGroupData = {
    //         packs: data.packs,
    //         addiblePacks: data.addiblePacks,
    //         labels: data.labels,
    //         giftPacks: data.giftPacks
    //       }
    //       let group = this._setGroupModel(newGroupData)
    //       this.groups = [group]
    //       this.data.groups = [newGroupData]
    //       group.packs.forEach((pack) => {
    //         pack.select()
    //       })
    //     })
    //     .catch((err) => {})
    // }

  }, {
    key: 'reloadGroup',
    value: function reloadGroup() {
      this.groups.forEach(function (group) {
        if (group.data.allChecked) {
          group.refreshAllPreview();
        } else {
          group.refreshAllPreviewNoEmit();
        }
      });
    }
  }, {
    key: '_refreshTotal',
    value: function _refreshTotal(data) {
      if (data === null) {
        this.data.price = 0;
        this.data.savedPrice = 0;
        this.data.postage = null;
        this.data.disabledSubmit = true;
        if (_util2.default.getClient() === 'points') {
          this.data.point = 0;
        }
      } else {
        this.data.price = data.price;
        this.data.savedPrice = data.savedPrice;
        this.data.postage = data.postage;
        this.data.disabledSubmit = false;
        if (_util2.default.getClient() === 'points') {
          this.data.point = data.point;
          this.data.usablePoint = data.usablePoint;
          this.data.disabledSubmit = data.usablePoint < data.point;
        } else if (_util2.default.getClient() === 'mobile') {
          var _previewPacks = data.packs || [];
          this.data.groups.forEach(function (_g, _i) {
            var _packs = _g.packs;
            _packs.forEach(function (_p, index) {
              var _packId = _p.id;
              _previewPacks.forEach(function (_previewPack) {
                if (_previewPack.id === _packId) {
                  _packs[index].giftPacks = _previewPack.giftPacks;
                }
              });
            });
          });
        }
      }
    }
  }, {
    key: '_setGroupsModel',
    value: function _setGroupsModel() {
      var _this6 = this;

      this.groups = [];
      this.data.groups.forEach(function (g) {
        var group = _this6._setGroupModel(g);
        _this6.groups.push(group);
      });
    }
  }, {
    key: '_setGroupModel',
    value: function _setGroupModel(g) {
      var _this7 = this;

      var group = create(Group, g);
      group.on('refresh-preview', function (data) {
        _this7._refreshTotal(data);
        if (_util2.default.getClient() === 'ipos') {
          emit('refresh-preview', iposCleanPacks(group.getPreviewPacks()));
        }
      }).on('select-change', function () {
        _this7.groupSelectChange(group);
      });
      return group;
    }
  }, {
    key: 'removeAllPacks',
    value: function removeAllPacks() {
      var packs = [];
      this.data.groups.forEach(function (group) {
        packs = packs.concat(group.packs);
      });
      this.removePacks(packs);
    }

    // getAllPacks () {
    //   const packs = []
    //   this.data.groups.forEach((group) => {
    //     group.packs.forEach((pack) => {
    //       if (pack.p_checked) {
    //         packs.push(pack)
    //         pack.giftPacks.forEach((giftPack) => {
    //           if (giftPack.owned) {
    //             packs.push(giftPack)
    //           }
    //         })
    //       }
    //     })
    //     group.giftPacks.forEach((giftPack) => {
    //       if (giftPack.owned) {
    //         packs.push(giftPack)
    //       }
    //     })
    //     group.addiblePacks.forEach((addiblePack) => {
    //       if (addiblePack.owned) {
    //         packs.push(addiblePack)
    //       }
    //     })

    //   })
    //   return packs
    // }

  }, {
    key: 'groupSelectChange',
    value: function groupSelectChange(group) {
      var _this8 = this;

      _util2.default.track('select-change', {
        editMode: this.data.editMode
      });
      if (this.data.editMode) {
        return;
      }
      var $refs = this.groups;
      var groupData = group.data;
      var cancelTitles = [];
      // self is exclusive, cancel others
      if (groupData.exclusive) {
        this.data.groups.forEach(function (gp, index) {
          var ref = $refs[index];
          if (gp.g_uid !== groupData.g_uid && ref.getCheckedPacks().length) {
            ref.unselectAll();
            ref.refreshPreview();
            cancelTitles.push(gp.title);
          }
        });
      }
      // self is not exclusive, cancel others which is exclusive
      if (!groupData.exclusive) {
        this.data.groups.forEach(function (gp, index) {
          var ref = $refs[index];
          if (gp.g_uid !== groupData.g_uid && gp.exclusive && ref.getCheckedPacks().length) {
            ref.unselectAll();
            ref.refreshPreview();
            cancelTitles.push(gp.title);
          }
        });
      }
      if (cancelTitles.length) {
        this.data.exclusiveTip = '\u4F60\u9009\u62E9\u4E86' + groupData.title + '\uFF0C' + cancelTitles.join('、') + '\u5DF2\u53D6\u6D88\u9009\u4E2D\u3002';
        this.data.showExclusiveTip = true;
        setTimeout(function () {
          _this8.data.showExclusiveTip = false;
        }, 3000);
      }
    }
  }, {
    key: 'editMode',
    value: function editMode(val) {
      this.data.editMode = val;
      this.groups.forEach(function (group) {
        group.editMode(val);
      });
    }
  }, {
    key: '_getModel',
    value: function _getModel() {
      var Model = {
        ipos: _ipos2.default,
        mobile: _mobile2.default,
        points: _points2.default
      };
      return Model[_util2.default.getClient()];
    }
  }]);
  return Model;
}(_events.EventEmitter);

exports.default = function () {
  return new Model();
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/index.js
// module id = 1139
// module chunks = 0